import React, {useEffect, useState} from 'react';
import {Link, useParams, useSearchParams} from 'react-router-dom';
import {useDispatch, useSelector} from "react-redux";

import {Box, Card, Grid, Tab, Tabs} from "@mui/material";

import {TabContext, TabPanel} from "@mui/lab";

import {useGetStateV2TOHQuery} from "../../core/api/toh-state-api";


import RawDataEdit from "./ba/RawDataEdit";
import ChargesList from "../Charger/chargesList";
import PaymentsRT from "../Payments/rt";
import Loading from "../../components/Common/Loading";
import RtConsumables from "../Consumables/rt";
import TechInfoRT from "../TechInfo/techInfoRT";
import RTLocationsTable from "./rt/RTLocationsTable";
import InGameListRT from "../InGame/InGameListRT";
import {stringify, parse} from "lossless-json";
import {isEmpty} from "../../core/utils/StringUtils";
import {useGetGuidMapMCQuery} from "../../core/api/mc-charge-api";
import {useGetStateV2MCQuery} from "../../core/api/mc-state-api";


function UserStatesMC(props) {

    const {action, tab: tabParam, subtab: subTabParam, game} = useParams()
    const CommonData = useSelector((state) => state.data.CommonData)
    const deviceId = CommonData.deviceId;
    const stateId = CommonData.stateId;
    const deviceIdIsEmpty = isEmpty(deviceId) && isEmpty(stateId);
    const errorMessage = CommonData.errorMessage;

    const link_prefix = '/' + game + '/' + action + '/' + deviceId + '/'
    const tab = tabParam || 'update'
    const subTab = subTabParam || (tab == 'analytics' ? 'payments' : 'consumables');
    const [params] = useSearchParams();
    const vendorIdParam = params.get('vendorId');
    let paramString = `?vendorId=${vendorIdParam}`

    const state = useSelector((state) => state.data.SolitaierState)

    //const state = useState()
    const dispatch = useDispatch();

    const {
        data: obj,
        isLoading,
        isSuccess,
        isError,
        error,
        status: objStatus
    } = useGetStateV2MCQuery({deviceId, stateId})


    const [tabIndex, setTabIndex] = useState(tab);
    const [subTabIndex, setSubTabIndex] = useState(subTab);

    const handleTabChange = (event, newTabIndex) => {
        setTabIndex(newTabIndex);
        setSubTabIndex(newTabIndex == 'analytics' ? 'payments' : 'consumables');
    };


    const handleSubTabChange = (event, newTabIndex) => {
        setSubTabIndex(newTabIndex);
    };


    useEffect(() => {

    }, [deviceId, dispatch]);

    let status = ""

    let content = ""
    let panel1 = ""
    let panel2 = ""

    let charges = ""

    const {
        data: guidMap,
    } = useGetGuidMapMCQuery()

    const addGuidNames = (list) => {
        guidMap.GlobalItemAll.forEach(({ guid, name }) => {
            if(list.hasOwnProperty(guid)) {
                list[guid]['name'] = name
            }
        });
        return list
    };
    const getBinaryFlags = (n) => {
        let binaryString = n.toString(2);
        return binaryString;
    }
    const addHeroGuidNames = (list) => {
        if(!guidMap?.hasOwnProperty('Hero')) return list

        guidMap.Hero.forEach(({ guid, name }) => {
            if(list.hasOwnProperty(guid)) {
                list[guid]['name'] = name
            }
        });

        Object.keys(list).forEach((key) => {
            try {
                list[key].Slots = getBinaryFlags(list[key].Slots) + ' ('+list[key].Slots+')'
            } catch (e) {
                list[key].Slots = JSON.stringify(list[key].Slots)
            }
        })

        return list

    };

    let isRaw = false
    let jsonData = null
    let data = {}

    if (typeof obj === "object" && obj.hasOwnProperty('data') && objStatus === 'fulfilled') {
        //const data = obj.data
        
        try {
            const raw = parse(atob(obj.value))
            data = JSON.parse(atob(obj.value))
            jsonData = raw

            if (data.hasOwnProperty('Records'))
                panel2 = <RTLocationsTable locations={data.Records.LocationProfile}/>


        } catch (e) {
            isRaw = true
            jsonData = obj.data
        }

        content = <TabContext value={tabIndex}>
            <Card>
                <Tabs value={tabIndex} onChange={handleTabChange}>
                    <Tab label="Update" value="update" component={Link} to={link_prefix + "update" + paramString}/>
                    <Tab label="InGame ItemProfile" value="ingame" component={Link} to={link_prefix + "ingame" + paramString}/>
                </Tabs>
            </Card>


            <TabPanel value="update">

                <RawDataEdit data={parse(atob(obj.value))}></RawDataEdit>
            </TabPanel>


            <TabPanel value="ingame">
                <TabContext value={subTabIndex}>
                    <Box className={"subtabs"}>
                        <Tabs value={subTabIndex} onChange={handleSubTabChange}>
                            <Tab label="Consumables" value="consumables" component={Link}
                                 to={link_prefix + "ingame/consumables"}/>
                            <Tab label="Transient" value="transient" component={Link}
                                 to={link_prefix + "ingame/transient"}/>
                            <Tab label="Unlimited" value="unlimited" component={Link}
                                 to={link_prefix + "ingame/unlimited"}/>
                            <Tab label="Permanent" value="permanent" component={Link}
                                 to={link_prefix + "ingame/permanent"}/>
                        </Tabs>

                        <TabPanel value="consumables">
                            <Card>
                                {data.hasOwnProperty("Records") && data.Records.hasOwnProperty("ItemProfile") &&
                                    <InGameListRT items={data.Records.ItemProfile.Consumables}/>
                                }
                            </Card>
                        </TabPanel>
                        <TabPanel value="transient">
                            <Card>
                                {data.hasOwnProperty("Records") && data.Records.hasOwnProperty("ItemProfile") &&
                                    <InGameListRT guidMapName="Transient" items={data.Records.ItemProfile.Transient}/>
                                }
                            </Card>
                        </TabPanel>
                        <TabPanel value="unlimited">
                            <Card>
                                {data.hasOwnProperty("Records") && data.Records.hasOwnProperty("ItemProfile") &&
                                    <InGameListRT items={data.Records.ItemProfile.Unlimited}/>
                                }
                            </Card>
                        </TabPanel>
                        <TabPanel value="permanent">
                            <Card>
                                {data.hasOwnProperty("Records") && data.Records.hasOwnProperty("ItemProfile") &&
                                    <InGameListRT guidMapName="Permanent" items={data.Records.ItemProfile.Permanent}/>
                                }
                            </Card>
                        </TabPanel>

                    </Box>
                </TabContext>
            </TabPanel>
        </TabContext>

    }

    return (
        <>
            <Loading isError={isError} isLoading={isLoading} error={error}>
                <div>{status}</div>
                <div>{content}</div>
            </Loading>


        </>
    );

}

export default UserStatesMC
